<template>
  <div>
    <v-text-field
      v-show="false"
      :name="name"
      :value="selectedStep"
    ></v-text-field>
    <svg
      :width="diagramWidth"
      :height="diagramHeight"
      viewBox="0 0 1200 250"
      class="workflow-svg"
    >
      <!-- Define arrow markers -->
      <defs>
        <marker
          id="arrowhead"
          markerWidth="8"
          markerHeight="6"
          refX="7"
          refY="3"
          orient="auto"
        >
          <polygon
            points="0 0, 8 3, 0 6"
            fill="#000000"
          />
        </marker>
        <marker
          id="arrowhead-back"
          markerWidth="8"
          markerHeight="6"
          refX="1"
          refY="3"
          orient="auto"
        >
          <polygon
            points="8 0, 0 3, 8 6"
            fill="#000000"
          />
        </marker>
      </defs>

      <!-- Forward arrows -->
      <line
        x1="110"
        y1="125"
        x2="180"
        y2="125"
        stroke="#000000"
        stroke-width="2"
        marker-end="url(#arrowhead)"
        class="arrow forward-arrow"
      />
      <line
        x1="320"
        y1="125"
        x2="380"
        y2="125"
        stroke="#000000"
        stroke-width="2"
        marker-end="url(#arrowhead)"
        class="arrow forward-arrow"
      />
      <line
        x1="580"
        y1="125"
        x2="640"
        y2="125"
        stroke="#000000"
        stroke-width="2"
        marker-end="url(#arrowhead)"
        class="arrow forward-arrow"
      />
      <line
        x1="760"
        y1="125"
        x2="980"
        y2="125"
        stroke="#000000"
        stroke-width="2"
        marker-end="url(#arrowhead)"
        class="arrow forward-arrow"
      />

      <!-- Backward arrow from polygon to previous wider box with squared path -->
      <path
        d="M 700 85 L 700 40 L 480 40 L 480 70"
        stroke="#000000"
        stroke-width="2"
        fill="none"
        marker-end="url(#arrowhead)"
        class="arrow backward-arrow"
      />

      <!-- Start Circle -->
      <circle
        cx="80"
        cy="125"
        r="25"
        :fill="currentStep === 0 ? '#e0e0e0' : '#ffffff'"
        stroke="#666666"
        stroke-width="2"
        class="workflow-element clickable"
        @click="handleClick(0)"
      />
      <text
        x="80"
        y="180"
        text-anchor="middle"
        fill="#000000"
        font-size="22"
        font-weight="bold"
        class="element-text"
        @click="handleClick(0)"
      >
        {{ $t('beginning') }}
      </text>

      <!-- Regular Box -->
      <rect
        x="190"
        y="75"
        width="120"
        height="100"
        rx="15"
        ry="15"
        :fill="currentStep === 1 ? '#e0e0e0' : '#ffffff'"
        stroke="#666666"
        stroke-width="2"
        class="workflow-element clickable"
        @click="handleClick(1)"
      />
      <text
        x="250"
        y="120"
        text-anchor="middle"
        fill="#000000"
        font-size="22"
        font-weight="bold"
        class="element-text"
        @click="handleClick(1)"
      >
        {{ $t('traffic') }}
      </text>
      <text
        x="250"
        y="150"
        text-anchor="middle"
        fill="#000000"
        font-size="20"
        class="element-text"
        @click="handleClick(1)"
      >
        {{ $t('hour_range', {s: 2, e: 4}) }}
      </text>

      <!-- Wider Box -->
      <rect
        x="390"
        y="75"
        width="180"
        height="100"
        rx="15"
        ry="15"
        :fill="currentStep === 2 ? '#e0e0e0' : '#ffffff'"
        stroke="#666666"
        stroke-width="2"
        class="workflow-element clickable"
        @click="handleClick(2)"
      />
      <text
        x="480"
        y="120"
        text-anchor="middle"
        fill="#000000"
        font-size="20"
        font-weight="bold"
        class="element-text"
        @click="handleClick(2)"
      >
        {{ $t('unfold') }}
      </text>
      <text
        x="480"
        y="150"
        text-anchor="middle"
        fill="#000000"
        font-size="18"
        class="element-text"
        @click="handleClick(2)"
      >
        {{ $t('consult_sla') }}
      </text>

      <!-- Polygon (Diamond) -->
      <polygon
        points="700,75 760,125 700,175 640,125"
        :fill="currentStep === 3 ? '#e0e0e0' : '#ffffff'"
        stroke="#666666"
        stroke-width="2"
        class="workflow-element clickable"
        @click="handleClick(3)"
      />
      <text
        x="700"
        y="120"
        text-anchor="middle"
        fill="#000000"
        font-size="20"
        font-weight="bold"
        class="element-text"
        @click="handleClick(3)"
      >
        {{ $t('approval') }}
      </text>
      <text
        x="700"
        y="150"
        text-anchor="middle"
        fill="#000000"
        font-size="18"
        class="element-text"
        @click="handleClick(3)"
      >
        {{ $t('hour_range', {s: 4, e: 8}) }}
      </text>

      <!-- End Circle -->
      <circle
        cx="1010"
        cy="125"
        r="25"
        :fill="currentStep === 4 ? '#e0e0e0' : '#ffffff'"
        stroke="#666666"
        stroke-width="2"
        class="workflow-element clickable"
        @click="handleClick(4)"
      />
      <text
        x="1010"
        y="180"
        text-anchor="middle"
        fill="#000000"
        font-size="22"
        font-weight="bold"
        class="element-text"
        @click="handleClick(4)"
      >
        {{ $t('end') }}
      </text>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'JobUnfoldDiagram',

  props: {
    currentStep: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      required: true
    },
  },

  data() {
    return {
      diagramWidth: 0,
      diagramHeight: 0,
      selectedStep: 0,
      stepPositions: {
        start: { x: 80, y: 125 },
        box: { x: 250, y: 125 },
        widerBox: { x: 480, y: 125 },
        polygon: { x: 700, y: 125 },
        end: { x: 1010, y: 125 }
      },
      stepDetails: {
        start: {
          title: 'Workflow Start',
          description: 'Initialize the workflow process and prepare all necessary resources.'
        },
        box: {
          title: 'Initial Processing',
          description: 'Perform initial data processing and validation steps.'
        },
        widerBox: {
          title: 'Main Processing',
          description: 'Execute the main processing logic with comprehensive data handling.'
        },
        polygon: {
          title: 'Decision Point',
          description: 'Evaluate results and determine next steps. May loop back for additional processing.'
        },
        end: {
          title: 'Workflow Complete',
          description: 'Finalize the workflow and output results.'
        }
      }
    }
  },

  mounted() {
    if(this.currentStep) {
      this.selectedStep = this.currentStep
    }
  },

  methods: {
    handleClick(step) {
      this.selectedStep = step
      this.$emit('step-clicked', this.selectedStep)
    },
  }
}
</script>

<style scoped>
.workflow-diagram {
  width: 100%;
  background: #fafafa;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.workflow-svg {
  width: 100%;
  height: auto;
  min-height: 50px;
  background: white;
}

.workflow-element {
  transition: all 0.3s ease;
}

.clickable {
  cursor: pointer;
}

.element-text {
  pointer-events: none;
  user-select: none;
}

.arrow {
  transition: stroke-width 0.3s ease;
}

.forward-arrow {
  stroke: #000000;
}

.backward-arrow {
  stroke: #000000;
}

.status-indicator {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.workflow-legend {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 15px;
  padding: 10px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
}

.legend-color {
  width: 12px;
  height: 12px;
  border-radius: 2px;
}

.forward-arrow-color {
  background: #2196F3;
}

.backward-arrow-color {
  background: #FF9800;
}

.begin-color {
  background: #4CAF50;
}

.task-color {
  background: #2196F3;
}

.decision-color {
  background: #FF9800;
}

.step-details {
  margin-top: 15px;
  padding: 15px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  border-left: 4px solid #2196F3;
}

.step-details h4 {
  margin: 0 0 10px 0;
  color: #1976D2;
}

.step-details p {
  margin: 0 0 15px 0;
  color: #666;
  line-height: 1.4;
}

.step-actions {
  display: flex;
  gap: 10px;
}

/* Responsive design */
@media (max-width: 768px) {
  .workflow-legend {
    flex-direction: column;
    gap: 10px;
  }

  .workflow-svg {
    height: 150px;
  }
}
</style>
